import { ClientStatus } from './client.model'

export class Team {
  clientId: number
  id: number
  type: TeamType
  clientName?: string
  clientStatus?: ClientStatus
  blockedBillingAt?: Date
  resellerId?: number
  resellerName?: string
  options?: TeamOptions
}

interface TeamOptions {
  isChevron?: boolean
}

export enum TeamType {
  Admin = 'admin',
  Client = 'client',
  Reseller = 'reseller',
}

export const TeamTypeLabel = {
  [TeamType.Admin]: 'MAIN.TEAM_TYPE.ADMIN',
  [TeamType.Client]: 'MAIN.TEAM_TYPE.CLIENT',
}
